<p>modify-object-type works!</p>
